module.exports = __webpack_public_path__ + "static/img/banner_2.a14af11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/banner_2.png
// module id = J65f
// module chunks = 1